<template>
  <el-dialog
    :visible.sync="isShow"
    width="480px"
    custom-class="ShortViewDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div class="dialog-body">
      <div class="d-header">
        <div class="left">
          <span>分享多个短链</span>
        </div>
        <fm-button
          @click="handleClose"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <div class="d-content">
        <!-- 公共说明 -->
        <div class="warn-box">
          <svg-btn icon-class="icon-tips-circle-fill" />
          <span>严禁分享反动、暴力、色情、违法及侵权内容的链接。</span>
        </div>
        <!-- 批量新建 -->
        <div class="shortLink">
          <!-- 分享短链 -->
          <div class="formBox" style="padding-bottom: 4px; margin-bottom: 0">
            <div class="fontBox">
              <span class="font">标题</span>
              <span class="font" style="margin-left: 198px">短链</span>
            </div>
            <div class="batchBox">
              <div class="batch" v-for="(item, index) in batchUrl" :key="index">
                <span class="bfont1">{{ item.url_title }}</span>
                <span class="bfont1" style="margin-right: 0">{{
                  item.share_url
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-footer">
        <fm-button
          @click="copyUrl(2)"
          round
          type="primary"
          size="mdeium"
          style="font-size: 14px"
          >复制标题和短链</fm-button
        >
        <fm-button
          @click="copyUrl(1)"
          round
          type="info"
          plain
          size="mdeium"
          style="font-size: 14px"
          >复制短链</fm-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    //是否显示
    isShow: {
      type: Boolean,
      default: false,
    },
    batchUrl: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {}
  },

  methods: {
    //关闭弹窗，清除状态
    handleClose() {
      this.$emit('handleClose')
    },
    //复制短链
    copyUrl(num) {
      let url
      if (num == 1) {
        let arr = []
        this.batchUrl.forEach(item => {
          arr.push(item.share_url)
        })
        url = arr.join('\n')
      } else if (num == 2) {
        // 处理数组，生成拼接后的字符串
        url = this.batchUrl
          .map(item => {
            return `${item.url_title} ${item.share_url}`
          })
          .join('\n')
      }
      this.$copyText(url).then(
        e => {
          let msg = num == 2 ? '复制标题和短链成功' : '复制短链成功'
          this.$toast(msg, 1)
        },
        function (e) {}
      )
    },
  },
}
</script>

<style lang="scss">
.ShortViewDialog {
  .el-dialog__body {
    padding: 0 !important;
  }
  .dialog-body {
    padding-bottom: 24px;
  }
  .d-header {
    margin: 20px 0 0 24px;
  }
  .d-content {
    .warn-box {
      height: 32px;
      @include useTheme {
        background: getVar('text-color1-f9f9f9');
      }
      display: flex;
      align-items: center;
      margin-top: 16px;
      .svg-icon {
        width: 16px;
        height: 16px;
        margin-left: 24px;
        margin-right: 8px;
      }
      span {
        font-size: 12px;
        line-height: 20px;
        @include useTheme {
          color: getVar('text-color1-8a8b92');
        }
      }
    }
    .file-info {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      .icon {
        width: 36px;
        height: 36px;
        margin-right: 16px;
        object-fit: cover;
      }
      .info {
        display: flex;
        flex-direction: column;
        .nameBox {
          display: flex;
          align-items: center;
          .name {
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            max-width: 368px;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            @include useTheme {
              color: getVar('text-color2-2c2c2c');
            }
          }
          .edit {
            width: 14px;
            height: 14px;
            margin-left: 4px;
            cursor: pointer;
            @include useTheme {
              color: getVar('text-color1-8a8b92');
            }
          }
        }
        .link {
          font-weight: 400;
          font-size: 12px;
          line-height: 20px;
          max-width: 368px;
          display: inline-block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          @include useTheme {
            color: getVar('text-color1-8a8b92');
          }
        }
      }
    }
    .shortLink {
      padding: 16px 24px 0 24px;
      .formBox {
        margin-bottom: 24px;
        .fontBox {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          .font {
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            @include useTheme {
              color: getVar('text-color1-2c2c2c');
            }
          }
          .red {
            @include useTheme {
              color: getVar('text-color1-F53F3F') !important;
            }
          }
          .icon {
            width: 16px;
            height: 16px;
            margin-left: 4px;
          }
        }
        .batchBox {
          width: 100%;
          height: 188px;
          background: #f6f6f6;
          border-radius: 8px;
          overflow-y: auto;
          padding: 10px 12px;
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          .batch {
            display: flex;
            align-items: center;
            .bfont1 {
              font-weight: 400;
              font-size: 12px;
              line-height: 20px;
              width: 194px;
              margin-right: 20px;
              @include multiline(1);
              @include useTheme {
                color: getVar('text-color1-2c2c2c');
              }
            }
          }
        }
      }
    }
  }
  .d-footer {
    margin: 20px 24px 0 0;
  }
}
</style>
